import styled from "styled-components";

export const SpidTypeSelectorBoxesContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    margin-top: 3rem;
`;

export const Footer = styled.div`
    background-color: ${props => props.theme.colors.background.whiteSmoke};
    padding: 0.75rem 0.5rem;
    display: flex;
    justify-content: flex-end;
    gap: 1.5rem;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
`;
